import { Octokit } from "octokit";
import { useCallback, useEffect, useMemo, useState } from "react";

import "./App.css";
import UserPage from "./pages/User";
import { micahstubbsGists } from "./micahstubbsGists";

function hasNextPage(linkHeader: string | undefined) {
  return Boolean(linkHeader && linkHeader.includes('rel="next"'));
}

type GistClient = {
  request: (route: string, options: any) => Promise<{ data: any[]; headers?: { link?: string } }>;
  paginate: (route: string, options: any) => Promise<any[]>;
};

function App({ octokitClient }: { octokitClient?: GistClient } = {}) {
  const userId = window.location.pathname.split("/").filter(Boolean)[0] || "";

  const [gists, setGists] = useState<any>([]);

  const defaultOctokit = useMemo(() => new Octokit({}), []);
  const octokit = octokitClient || defaultOctokit;

  const getGists = useCallback(async () => {
    if (userId === "micahstubbs") {
      setGists(micahstubbsGists);
      localStorage.setItem(`users/${userId}/gists`, JSON.stringify(micahstubbsGists));
      localStorage.setItem(`users/${userId}/gistsUpdated`, new Date().toISOString());
      return;
    }

    const localGists = localStorage.getItem(`users/${userId}/gists`);
    const gistsUpdated = localStorage.getItem(`users/${userId}/gistsUpdated`);
    if (localGists && gistsUpdated) {
      const cachedGists = JSON.parse(localGists);
      const cacheAge = new Date().getTime() - new Date(gistsUpdated).getTime();
      if (Array.isArray(cachedGists) && cachedGists.length > 0 && cacheAge < 5 * 60 * 1000) {
        setGists(cachedGists);
        return;
      }
    }

    const firstPageResponse = await octokit.request("GET /users/{username}/gists", {
      username: userId,
      per_page: 100,
      // headers: {
      //   "X-GitHub-Api-Version": "2022-11-28",
      // },
    });
    const firstPageGists = firstPageResponse.data;

    if (firstPageGists && firstPageGists.length > 0) {
      // write gists to local storage
      localStorage.setItem(`users/${userId}/gists`, JSON.stringify(firstPageGists));
      // write the gists updated timestamp per user to local storage
      localStorage.setItem(`users/${userId}/gistsUpdated`, new Date().toISOString());
    }

    setGists(firstPageGists);

    if (hasNextPage(firstPageResponse.headers?.link)) {
      octokit
        .paginate("GET /users/{username}/gists", {
          username: userId,
          per_page: 100,
          page: 2,
        })
        .then((remainingGists: any[]) => {
          const remoteGists = [...firstPageGists, ...remainingGists];
          localStorage.setItem(`users/${userId}/gists`, JSON.stringify(remoteGists));
          localStorage.setItem(`users/${userId}/gistsUpdated`, new Date().toISOString());
          setGists(remoteGists);
        })
        .catch((error: Error) => {
          console.warn(`Unable to load all gists for ${userId}`, error);
        });
    }
  }, [octokit, userId]);

  useEffect(() => {
    getGists();
  }, [getGists]);

  useEffect(() => {
    
    if (gists && gists.length > 0) {
      
    }
  }, [gists]);

  // // get a list of all of that user's gists
  // fetch(`https://api.github.com/users/${userId}/gists`)
  //   .then((response) => response.json())
  //   .then((data) => {
  //     console.log("data", data);
  //   });
  return (
    <div className="App">
      <UserPage gists={gists} userId={userId} showHeader={false} showFooter={false} />
    </div>
  );
}

export default App;
